import callAPiBase from './base';

const linesApi = {
  list: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/lineList',
      method: 'GET',
      useToken: true,
      title: 'Lines - Get List',
      params,
    }),
  get: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/lineList',
      method: 'GET',
      useToken: true,
      title: 'Lines - Get',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/lineCreate',
      method: 'POST',
      useToken: true,
      title: 'Line - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/lineUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Line - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/lineDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Line - Delete',
      params,
    }),
  updateBenefits: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/lineUpdateBenefits',
      method: 'POST',
      useToken: true,
      title: 'Line - Update Benefits',
      data,
    }),
  conectivity: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/connectivityGet',
      method: 'POST',
      useToken: true,
      title: 'Conectivity - Get',
      data,
    }),
  updateLineFare: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/lineSectionUpdateFare',
      method: 'PUT',
      useToken: true,
      title: 'Line - Update',
      data,
    }),
};

export { linesApi };
export default linesApi;
